import { render, staticRenderFns } from "./importPartsDialog.vue?vue&type=template&id=23c003cc&scoped=true&"
import script from "./importPartsDialog.vue?vue&type=script&lang=js&"
export * from "./importPartsDialog.vue?vue&type=script&lang=js&"
import style0 from "./importPartsDialog.vue?vue&type=style&index=0&id=23c003cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c003cc",
  null
  
)

export default component.exports